import { render, staticRenderFns } from "./PrivacySection.vue?vue&type=template&id=fe3ad844&"
import script from "./PrivacySection.vue?vue&type=script&lang=js&"
export * from "./PrivacySection.vue?vue&type=script&lang=js&"
import style0 from "./PrivacySection.vue?vue&type=style&index=0&id=fe3ad844&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports